import React from 'react';
import Spinner from 'react-spinkit';
import {connect} from 'react-redux';
import {getCompany} from "../../actions/companies";
import AddressLink from "../AddressLink";
import {compose} from "redux";
import {withLoading2} from "./deferLoaderHoc";
import LinkButton from "./LinkButton";
import {Tooltip} from "antd";

export const CompanyCardSimple = ({ onMount, loading, id, company, profile }) => {
  if (loading) {
    return <div><Spinner name='line-scale'/></div>
  }
  return (
    <div>
      <div className='company-card-name-link'>
        {(company.resource.profileprivacy > 0 || (profile && profile.companyid === company.resource.id)) &&
        <Tooltip title={'Go to PQF'}><LinkButton type='primary' icon='solution' size='small'
                    to={`/@/${company.resource.companyname.replace(/[^\w]+/g, '').toLocaleLowerCase()}`}/></Tooltip>}
        <h3>{company.resource.companyname}</h3>
      </div>
      <AddressLink
        address={{
          street: [company.resource.address, company.resource.address2].join('\n'),
          city: company.resource.city,
          state: company.resource.state,
          zip: company.resource.zip
        }}
      />
    </div>
  );
};

const mapState = (state, ownProps) => {
  let company = state.companies.data[ownProps.id];
  if (!company) {
    return {
      company: {
        resource: { id: ownProps.id },
        cache: { loading: true }
      },
      profile: state.profile,
    };
  } else return { company };
};

export default compose(
  connect(mapState),
  withLoading2(
    ({ company: { resource: { id }}}, dispatch) => id && dispatch(getCompany(id)),
    () => <Spinner name='line-scale'/>,
    null,
    ['company']
  )
)(CompanyCardSimple);



// WEBPACK FOOTER //
// ./src/components/Boilerplate/CompanyCard.js